import '../../modules/mode-components';

import * as angular from 'angular';

import { getCurrentUsername, getOwnerUsername } from '@mode/shared/util-js';

import GroupMembershipModalController from '../group-membership/group-membership-modal-controller';
import GROUP_MEMBERSHIP_MODAL from '../group-membership/group-membership-modal.html';
import CreateGroupModalController from './create-group-modal-controller';
import CREATE_GROUP_MODAL from './create-group-modal.html';

const createGroupDirective = function (Modal, GroupModel, AccountModel, AlertService, $q, $window) {
  return {
    restrict: 'A',
    scope: {
      owner: '<?',
      account: '<?',
      name: '@?',
      onCreate: '&',
      redirectOnCreate: '@',
      groupAccount: '@?',
    },
    link: function ($scope: any, elem) {
      function handleGroupMemberships(group) {
        // TODO: handle group memberships modal
        const groupMembershipModal = Modal.open(
          {
            group,
            owner: $scope.owner,
            account: $scope.account,
          },
          {
            controller: GroupMembershipModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: GROUP_MEMBERSHIP_MODAL,
          }
        );

        return groupMembershipModal.result.then(() => group).catch(function () {});
      }

      function selectGroup(group) {
        if ($scope.redirectOnCreate) {
          // TODO: goto group show page
        } else {
          GroupModel.refresh(group);
          AlertService.success('Group created');

          // envoke the callback
          $scope.onCreate();
        }
      }

      function saveGroup(group) {
        const params = {
          'user_group.name': group.name,
          includes: ['new_group_membership'],
        };

        return GroupModel.create({
          account: $scope.owner.username,
          params,
        });
      }

      function handleModal() {
        const modal = Modal.open(
          {
            owner: $scope.owner,
            name: $scope.name,
          },
          {
            controller: CreateGroupModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: CREATE_GROUP_MODAL,
          }
        );

        modal.result
          .then(saveGroup)
          .then(handleGroupMemberships)
          .then(selectGroup)
          .catch(function () {});
      }

      function getOwnerAndAccount() {
        const ownerToken = $scope.groupAccount ? $scope.groupAccount : getOwnerUsername($window.document);
        const accountUsername = getCurrentUsername($window.document);
        return $q
          .all([
            AccountModel.find({
              username: ownerToken,
              useEntryPath: true,
              includes: ['new_group'],
              refresh: true,
              cacheBust: 'createGroup',
            }),
            AccountModel.find({
              username: accountUsername,
              useEntryPath: true,
            }),
          ])
          .then($q.spread(saveOwnerAndAccount.bind(this)));
      }

      function saveOwnerAndAccount(owner, account) {
        $scope.owner = owner;
        $scope.account = account;
        return owner;
      }

      elem.on('click.context', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!$scope.owner) {
          getOwnerAndAccount().then(handleModal.bind(this));
        } else {
          handleModal();
        }
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.createGroup'));
    },
  };
};

createGroupDirective.$inject = ['ModalService', 'GroupModel', 'AccountModel', 'ToastService', '$q', '$window'];

angular.module('mode.components').directive('createGroup', createGroupDirective);
